
<script>
	import listBase from '@_system/components/base/list.vue'
	import settlementtree from '../lib/datetree/tree.vue'
	import reconciliation from './lib/reconciliation/index.vue'
	import staticIndex from './lib/static/index.vue'
	import underlineIndex from './lib/underline/index.vue'
	//import html2canvas from 'html2canvas';
	// import vueQr from 'vue-qr'
	// import OSS from 'ali-oss'
	export default {
		extends: listBase,
		name: 'reconciliationbillIndex',
		props: {

		},
		render(h) {
			this.$slots.aside = [ <settlementtree ref = "settlementtree"key = {this.settlementtreeKey} onSelect = {this.settlementtreeChange}/>
			]		
			this.$slots.header = [			
				
				// <el-breadcrumb separator-class="el-icon-arrow-right" >
				// 	{
				// 		this.parentbread.length!=0?this.parentbread.map((item,index)=>{
				// 		return <el-breadcrumb-item key={index}>{item.name}</el-breadcrumb-item>
				// 	}):<el-breadcrumb-item>{'月结对账单'}</el-breadcrumb-item>
					
				// 	}			
				// </el-breadcrumb>,
				<static-index nodeid={this.nodeid} ref="reconciliationbillstaticIndex" />,
			]
			this.$slots.plug = [
				<reconciliation currentrow={this.currentrow} ref="reconciliation" onSuccess={this.success}  />,
				<underline-index currentrow={this.currentrow} ref="underlineIndex" onSubmit={this.submitunderline}  />
			]	
			return listBase.render.call(this, h)
		},
		data() {
			return {
				asideWidth:150,
				printShow:true,
				ma:'DZ',
				moduleName: 'reconciliationbill',
				windowName: '月结对账',
				windowType: 'window',
				settlementtreeKey: Math.random(),
				nodeid: [],
				parentbread: [],
				currentrow:null,
				list_footerField: [{
					field: 'discountamount',
					toFixed: 4
				}]
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {

		},
		computed: {

		},

		methods: {
			afterGet(){
	
				this.$refs.reconciliationbillstaticIndex.init()
			},
			sendemail(row){
				this.$confirm('是否确认发送','提示').then(()=>{
					this.loading = true
					this.$api.reconciliationbill.sendBilltask({ids:[row.id]}).then(() => {
						this.loading = false
						this.$message.success('创建发送任务成功')
					}, () => {
						this.loading = false
					})
				})
				// this.ma = row.code
				// this.$nextTick(()=>{
				// 	let base64 = this.$refs.settlementMa.$el.currentSrc
				// 	let file = this.base64ToFile(base64,this.ma,'image/png')
				// 	this.uploadOss()
				// 	console.log(base64)
				// })
			},
			sendemailbatch(){
				let data = this.$refs[this.moduleName+'_list'].getCheckboxRecords()
				if(data.length==0){
					this.$message.error('请选择数据')
					return
				}
				let ids = []
				data.forEach((item)=>{
					ids.push(item.id)
				})
				this.$confirm('是否确认发送','提示').then(()=>{
					this.loading = true
					this.$api.reconciliationbill.sendBilltask({
						type:'bill',
						ids:ids,
					}).then(() => {
						this.loading = false
						this.$message.success('创建发送任务成功')
					}, () => {
						this.loading = false
					})
				})				
			},
			sendinvoicebatch(){
				let data = this.$refs[this.moduleName+'_list'].getCheckboxRecords()
				data = data.filter((item)=>{
					return item.status == 1
				})
				if(data.length==0){
					this.$message.error('请选择已核对数据')
					return
				}
				let ids = []
				data.forEach((item)=>{
					ids.push(item.id)
				})
				this.$confirm('是否确认发送','提示').then(()=>{
					this.loading = true
					this.$api.reconciliationbill.sendBilltask({
						type:'invoice',
						ids:ids,
					}).then(() => {
						this.loading = false
						this.$message.success('创建发送任务成功')
					}, () => {
						this.loading = false
					})
				})				
			},
			
			
			
			print(row){
				this.$api.reconciliationbill.downloadprinttemplate({id:row.id}).then((res)=>{
					let blob  = new Blob([res])
					const link = document.createElement('a')
					link.href = URL.createObjectURL(blob);
					link.download = '付款申请书_' + row.code + '.xlsx'
					document.body.appendChild(link)
					link.click();
					document.body.removeChild(link)
					
					// Release the object URL
					URL.revokeObjectURL(link.href);
				})
			},
			download(){
				let data = this.$refs[this.moduleName+'_list'].getCheckboxRecords()
				if(data.length==0){
					this.$message.error('请选择数据')
					return
				}
				let ids = []
				data.forEach((item)=>{
					ids.push(item.id)
					//console.log(item)
				})
				this.loading = true
				this.$api.reconciliationbill.download({ids:ids}).then((res)=>{
					let url = new Blob([res])
					let link = document.createElement('a')
					link.style.display = 'none'
					link.href = URL.createObjectURL(url)
					link.setAttribute('download', '对账单.zip')
					document.body.appendChild(link)
					link.click();
					link.remove();
					this.loading = false
				},()=>{
					this.loading = false
				})
			},
			submitunderline(e){
				console.log(e,123123)
				this.loading = true
				this.$api.reconciliationbill.checkunderline({id:this.currentrow.id,file_underline:e.data}).then(()=>{
					this.$message.success('操作成功')
					this.customreload()
					this.$refs.underlineIndex.modal_cancel()
					this.loading = false
				},()=>{
					this.loading = false
				})
			},
			checkunderline(row){
				this.currentrow = row
				this.$nextTick(()=>{
					this.$refs.underlineIndex.modal_show()
				})
			},
			// base64ToFile(base64, filename, mimeType) {
			// 	const byteString = atob(base64.split(',')[1]);
			// 	const arrayBuffer = new ArrayBuffer(byteString.length);
			// 	const uint8Array = new Uint8Array(arrayBuffer);
			// 	for (let i = 0; i < byteString.length; i++) {
			// 		uint8Array[i] = byteString.charCodeAt(i);
			// 	}
			// 	const blob = new Blob([arrayBuffer], { type: mimeType });
			// 	return new File([blob], filename, { type: mimeType });
			// },			
			// uploadOss(file, moduleName) {
			// 	return new Promise((reslove, reject) => {
			// 		let client = new OSS(window.config.oss);
			// 		let name = moduleName + '/' + Date.now() + '_' + (Math.random() * 100000).toFixed(0) + file
			// 			.name
			// 		client.put(name, file).then((res) => {
			// 			reslove(res)
			// 		}).catch((e) => {
			// 			reject(e)
			// 		})
			// 	})
			// },
			maloaded(){
				
			},
			add() {
				if(this.nodeid.length==0 || this.nodeid[0].toString().startsWith('year')){				
					this.$message.error('请选择月份')
					return
				}
				this.addformShow({
					billtime:this.nodeid[0]/1000,
				})
			},
			reconciliation(row){
				this.currentrow = row
				this.$nextTick(()=>{
					this.$refs.reconciliation.modal_show()
				})
			},
			settlementtreeChange(e) {
				this.parentbread = []
				this.nodeid = e.parentid != 0 ? [e.id] : e.childrenid
				if (e.parentid != 0) {
					this.parentbread.push({
						id: e.parentid,
						name: e.parentid
					})
				}
				this.parentbread.push({
					id: e.id,
					name: e.name
				})
				this.customreload()
			},
			beforeRequest(form) {
				form.nodeid = this.nodeid
			},
			addfinbill(row,action='build'){
				this.loading = true
				this.$api.reconciliationbill.addfinbill(row.id,{action:action}).then((res) => {
					this.loading = false
					if(res==1){
						this.$message.success('操作成功')
						this.customreload()
					}else{
						this.$confirm('核对未完成，生成付款单前会自动删除未核对单据，以便下次核对').then(()=>{
							this.addfinbill(row,'fourcebuild')
						})
					}
				}, () => {
					this.loading = false
				})
			},
			repairfinbill(row){
				this.loading = true
				this.$api.reconciliationbill.repairfinbill(row.id).then(()=>{
					this.loading = false
					this.$message.success('操作成功')
				},()=>{
					this.loading = false
				})
			},
			closefinbill(row){
				this.$confirm('是否确认关闭').then(()=>{
					this.$api.reconciliationbill.closefinbill(row.id).then(()=>{
						this.customreload()
					})
					
				})
			},
			success(){
				this.customreload()
			},
			cellStyle({
				row,
				column
			}) {
				let map = {
					status:{
						0:'#F56C6C',
						1:'#67C23A',
						2:'#409EFF',
					}
					
				}	
				if(map[column.field]){
					return {
						color: map[column.field][row[column.field]]
					}
				}					
			},
		},
		components: {
			reconciliation,
			staticIndex,
			underlineIndex
			// vueQr
		}
	}
</script>
